import React, { useContext } from "react";
import styled from "styled-components";
import ReactHtmlParser from "react-html-parser";
import { EventContext } from "Components";
import { Layout } from "../Layout";

export const PreCampaign = () => {
  const { event } = useContext(EventContext);

  const api = process.env.REACT_APP_FIRE_BASE_STORAGE_API;
  const storageDirectory = event.storageDirectory;

  return (
    <Layout showHeader preCampaign flexGrow showFooter>
      <PageContent>
        <h2>{ReactHtmlParser(event.preCampaign.heading)}</h2>
      </PageContent>
    </Layout>
  );
};

const PageContent = styled.div`
  width: 100%;
  color: #ffffff;
  background-color: #000013;
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;

  h2 {
    font-size: clamp(18px, 9vw, 64px);
    line-height: 1;
    text-transform: uppercase;
    margin-top: 0;
    text-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
    border-left: 5px solid #c41230;
    padding-left: 25px;
  }
`;
